const setUserSession = (data) => {
  localStorage.setItem("id", data.id);
  localStorage.setItem("nombres", data.nombres);
  localStorage.setItem("apellidos", data.apellidos);
  localStorage.setItem("rut", data.rut);
  localStorage.setItem("email", data.email);
  localStorage.setItem("codigo", data.codigo);
  localStorage.setItem("estado", data.estado);
  localStorage.setItem("telefono", data.telefono);
  localStorage.setItem("roles", JSON.stringify(data.roles));
  localStorage.setItem("permissions", JSON.stringify(data.permisos));
  localStorage.setItem("avatar", JSON.stringify(data.avatar));
};

const clearUserSession = () => {
  localStorage.clear();
};

const getUserData = () => {
  let userData = {
    fullName: "",
    id: localStorage.getItem("id"),
    nombres:
      localStorage.getItem("nombres") != "undefined" &&
      localStorage.getItem("nombres") != "null"
        ? localStorage.getItem("nombres")
        : null,
    apellidos:
      localStorage.getItem("apellidos") != "undefined" &&
      localStorage.getItem("apellidos") != "null"
        ? localStorage.getItem("apellidos")
        : null,
    rut:
      localStorage.getItem("rut") != "undefined" &&
      localStorage.getItem("rut") != "null"
        ? localStorage.getItem("rut")
        : "-",
    email:
      localStorage.getItem("email") != "undefined" &&
      localStorage.getItem("email") != "null"
        ? localStorage.getItem("email")
        : "-",
    codigo:
      localStorage.getItem("codigo") != "undefined" &&
      localStorage.getItem("codigo") != "null"
        ? localStorage.getItem("codigo")
        : "-",
    estado:
      localStorage.getItem("estado") != "undefined" &&
      localStorage.getItem("estado") != "null"
        ? localStorage.getItem("estado")
        : "-",
    telefono:
      localStorage.getItem("telefono") != "undefined" &&
      localStorage.getItem("telefono") != "null"
        ? localStorage.getItem("telefono")
        : "-",
    roles:
      localStorage.getItem("roles") != "undefined" &&
      localStorage.getItem("roles") != "null"
        ? JSON.parse(localStorage.getItem("roles"))
        : [],
    permissions:
      localStorage.getItem("permissions") != "undefined" &&
      localStorage.getItem("permissions") != "null"
        ? JSON.parse(localStorage.getItem("permissions"))
        : [],
  };

  if (userData.nombres && userData.apellidos) {
    userData.fullName = `${userData.nombres} ${userData.apellidos}`;
  } else {
    userData.fullName =
      (userData.nombres || userData.apellidos) ?? "Usuario sin nombre";
  }

  return userData;
};

export {
  setUserSession,
  clearUserSession,
  getUserData,
};
